import CardPage7 from "./cardpage7";
import Title7 from "./title7";

export default function Page7(){
    return(
    <>
    <Title7/>
    <CardPage7/>
    </>
    )
}